import ApplicationController from './application_controller';

// Reference panel collapse / expand toggle.
//
// Mounted on the row that wraps the form column + the aside, so a toggle
// button in the form's card-header (outside the aside) can dispatch to the
// same controller as the aside's own close button. When collapsed the aside
// hides and the form column expands to full width; when expanded the form
// returns to col-md-8 / panel returns to col-md-4. State persists in
// localStorage keyed by document type.
//
// The form-header "References" button hides while the panel is open — the
// panel's own ">>" close button is the way to dismiss it from there.
//
// See docs/visit-notes-cfs-post-rollout.md ("Reference Panel" section).
export default class extends ApplicationController {
  static targets = ['expanded', 'toggleButton'];
  static values  = { storageKey: String };

  static ROW_COLLAPSED_CLASS = 'reference-panel--row-collapsed';

  connect() {
    if (this.#storedAsCollapsed()) {
      this.#applyCollapsed();
    } else {
      this.#applyExpanded();
    }
  }

  toggle(event) {
    this.#hideTooltip(event);
    if (this.element.classList.contains(this.constructor.ROW_COLLAPSED_CLASS)) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  collapse(event) {
    this.#hideTooltip(event);
    this.#applyCollapsed();
    this.#store('1');
  }

  expand(event) {
    this.#hideTooltip(event);
    this.#applyExpanded();
    this.#store('0');
  }

  #applyCollapsed() {
    if (this.hasExpandedTarget) this.expandedTarget.hidden = true;
    this.element.classList.add(this.constructor.ROW_COLLAPSED_CLASS);
    this.toggleButtonTargets.forEach(btn => btn.hidden = false);
  }

  #applyExpanded() {
    if (this.hasExpandedTarget) this.expandedTarget.hidden = false;
    this.element.classList.remove(this.constructor.ROW_COLLAPSED_CLASS);
    this.toggleButtonTargets.forEach(btn => btn.hidden = true);
  }

  #hideTooltip(event) {
    if (event && event.currentTarget && window.$) {
      $(event.currentTarget).tooltip('hide');
    }
  }

  #storedAsCollapsed() {
    try {
      return window.localStorage.getItem(this.storageKeyValue) === '1';
    } catch (_) {
      return false;
    }
  }

  #store(value) {
    try {
      window.localStorage.setItem(this.storageKeyValue, value);
    } catch (_) {
      // localStorage unavailable (private mode, quota exceeded) — silently no-op
    }
  }
}
